import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface IAuditLog {
  id: number | null;
  auditName: string | null;
}

const initialState: IAuditLog = {
  id: null,
  auditName: null,
};

export const auditLogSlice = createSlice({
  name: "auditLog",
  initialState,
  reducers: {
    setAuditLogInfo: (state, action: PayloadAction<IAuditLog>) => {
      state.id = action.payload.id;
      state.auditName = action.payload.auditName;
    },
    resetAuditLogInfo: (state) => {
      state.id = initialState.id;
      state.auditName = initialState.auditName;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setAuditLogInfo, resetAuditLogInfo } = auditLogSlice.actions;

export default auditLogSlice.reducer;
